import FJTextStyled from '../FJTextStyled';
import FJDomRenderManager from './FJDomRenderManager';

/**
 * @desc 用来管理元素的渲染状态，开始输出元素，停止输出元素
 */
class FJElementsRender {
    _elements = {}; // 元素集合

    /**
     * @desc
     * @param props
     */
    constructor(props) {}

    /**
     * @desc 元素是否正在渲染
     * @param element
     * @return {boolean}
     */
    isElementRendering(element) {
        const id = element.getId();
        return !!this._elements[id];
    }

    /**
     * @desc 开始渲染元素
     * @param element
     * @param timeRange, 元素在工程中的事件范围
     * @param exportSize
     */
    startElementRender(element, timeRange, exportSize, isRealFrame = false) {
        const id = element.getId();
        this._elements[id] = {
            element,
            timeRange,
        };
        if (element instanceof FJTextStyled) {
            element.prepareToExport(exportSize, isRealFrame);
            return;
        }
        element.prepareToExport(exportSize);
    }

    /**
     * @desc 停止渲染已过时的元素
     * @param time
     */
    stopElementsAtTime(time) {
        const FAIL_OVER_TIME = 1; // 容错，避免被错误停止
        Object.keys(this._elements).forEach(id => {
            const { element, timeRange } = this._elements[id];
            if (time > timeRange.endTime + FAIL_OVER_TIME) {
                element.stopExport();
                delete this._elements[id];
                FJDomRenderManager.removeRender(element.getId());
            }
        });
    }

}

const elementsRender = new FJElementsRender();

export default elementsRender;
